import useDiscard from "../../useDiscard";
import useMap from "../../utils/useMap";
import useWeakMap from "../../utils/useWeakMap";
import { getRootProps } from "../chain/store/useStoreRoot";
import isAvoidEmitCase from "./avoidEmitCase";

/**
 * @type {UseOnLayerGet.store}
 */
const store = useWeakMap();

const hasLayer = layer => store.has(layer);

const storePrivateKey = useMap();
const storePropPrivateKey = useWeakMap();

const isPrivateKeyValid = (privateKey) => typeof privateKey === 'symbol' && storePrivateKey.has(privateKey);

const generatePrivateKey = () => Symbol('layerGetter')

const onDiscardProp = prop => {
    store.delete(prop);
    const privateKey = storePropPrivateKey.get(prop);
    if (privateKey) {
        storePrivateKey.delete(privateKey);
    }
}

/**
 * 
 * @param {object} layer 
 * @returns {Set<UseOnLayerGet.FnOnLayerGet>}
 */
const getCallbacks = layer => store.get(layer) || [];

const addItem = (layer, cb) => {
    const targetLayer = getRootProps(layer) || layer;
    if (!store.has(targetLayer)) {
        store.set(targetLayer, new Set())
    }
    store.get(targetLayer).add(cb);
}

const deleteItem = (layer, cb) => {
    const targetLayer = getRootProps(layer) || layer;
    store.get(targetLayer).delete(cb);
}

/**
 * @type {UseOnLayerGet.useOnLayerGet}
 */
const useOnLayerGet = (layer, cb) => {
    if (typeof cb !== 'function' || !hasLayer(layer)) {
        return;
    }
    addItem(layer, cb);
    return () => deleteItem(layer, cb)
}

/**
 * 
 * @type {UseOnLayerGet.emitLayerGet} 
 */
const emitLayerGet = (privateKey, propertyPath, key, value) => {
    if (isAvoidEmitCase(key)) return value
    else if (!isPrivateKeyValid(privateKey)) return value;

    let remakeValue = value;
    const layer = storePrivateKey.get(privateKey);
    const parentLayer = getRootProps(layer);
    const targetLayer = parentLayer || layer;
    if (!targetLayer) {
        return value;
    }
    propertyPath.push(key);
    const absKey = propertyPath.pathToString();

    getCallbacks(targetLayer).forEach((cb) => {
        remakeValue = cb(propertyPath, absKey, key, value)
    })
    return remakeValue !== undefined ? remakeValue : value;
}

/* Must init first, if not, the trigger will not work */
const initOnLayerGet = (layer) => {
    if (hasLayer(layer)) {
        return
    }
    const privateKey = generatePrivateKey();
    // store.set(layer,new Set())
    storePrivateKey.set(privateKey, layer);
    storePropPrivateKey.set(layer, privateKey);
    /* Destroy when layer discard */
    useDiscard(layer, onDiscardProp)
    return privateKey
}

export default useOnLayerGet
export {
    emitLayerGet,
    initOnLayerGet
}